import React from "react";
import BrandManagerShell from "./components/BrandManagerShell";
import Support from "./support";

/**
 * Client Support Hub hosted in the Brand Manager shell.
 * Does not select a brand and does not mount MasterLayout / brand sidebar.
 */
export default function BrandManagerSupport() {
  return (
    <BrandManagerShell>
      <Support />
    </BrandManagerShell>
  );
}
